module.exports = __webpack_public_path__ + "themes/mf/img/prize-8@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-8@2x.png
// module id = 101
// module chunks = 3